import React,{useEffect, useState} from 'react'
import { useDebounce } from 'use-debounce'

// to reduce API calls we use DEbounce. Otherwise for each letter, API call is made. By using this debounce ,we make API call only after a certain duration

import { useResultContext } from '../context/ResultContextProvider'
import { Links } from './Links'




export const Search = () => {

    const [text,setText] = useState('Walmart');
    const {setSearchWord} =useResultContext();
    const [debouncedValue] = useDebounce(text,300);

    useEffect(() => {
        if(debouncedValue) setSearchWord(debouncedValue)
        
    }, [debouncedValue])


    return (
        <div className="relative sm:ml-48 md:ml-72 sm:-mt-14 mt:3">
            <input value={ text} type="text" className="sm:w-96 w-80  p-5 h-10 dark:bg-slate-200 border rounded-full shadow-sm outline-none text-black hover:shadow-lg" 
            placeholder="Search or Type URL"
            onChange={(e) => setText(e.target.value)}
            />

            {!text && (
                <button type="button" className="absolute top-2 right-3 text-xl text-gray-500" 
                onClick={()=> setText('')}>
                    X
                </button>
            )}
            
            <Links/>
        </div>
    )
}
